module.exports = __webpack_public_path__ + "static/media/write-note.b69f438d.svg";